/**
 * Route for `multi-language-partner-portal`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MultiLanguagePartnerPortalPage } from "../features/multi-language-partner-portal/MultiLanguagePartnerPortalPage";

export const multiLanguagePartnerPortalRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/multi-language-partner-portal",
	component: MultiLanguagePartnerPortalPage,
});

export default multiLanguagePartnerPortalRoute;
